import axios from 'axios'
import urlGenerator from './url-generator'
import { property } from 'lodash'
import createRequestConfig from './create-request-config'

const postData = ({
    subject,
    content,
    recipientIds,
}) => {
    const url = urlGenerator.messages()
    const message = {
        subject,
        content,
        recipientIds,
    }
    return axios.post(url, message, createRequestConfig()).then(property('data'))
}

export default postData